import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import { transformFiltersToQuery } from './utils/transformFilterToQuery';

export const formSlice = createSlice({
    name: 'form',
    initialState: {
        pending: false,
        savePending: false,
        formConfig: null,
        error: null,
    },
    reducers: {
        start: (state, action) => {
            state.pending = true;
        },
        stop: (state, action) => {
            state.pending = false;
        },
        startSave: (state, action) => {
            state.savePending = true;
        },
        stopSave: (state, action) => {
            state.savePending = false;
        },
        setError: (state, action) => {
            state.pending = false;
            state.error = action.payload;
        },
        setFormConfig: (state, action) => {
            state.formConfig = action.payload;
        },
    },
});

export const {
    start,
    stop,
    setFormConfig,
    setError,
    startSave,
    stopSave,
} =
    formSlice.actions;

export const getFormsSavePending = (state) => state.form.savePending;
export const getFormConfig = (state) => state.form.formConfig;

export const createFormAction =
    ({ data, onSuccess, onFailure }) =>
    async (dispatch) => {
        try {
            dispatch(startSave());
            api.post('forms', data)
                .then((response) => {
                    dispatch(stopSave());
                    if (onSuccess) {
                        onSuccess(response.data);
                    }
                    return response;
                })
                .catch((error) => {
                    if (onFailure) {
                        onFailure(error);
                    }
                    dispatch(setError(error));
                    dispatch(stopSave());
                });
        } catch (e) {
            dispatch(stopSave());
            return console.error('error', e);
        }
    };

export const updateFormAction =
    ({ id, data, onSuccess, onFailure }) =>
    async (dispatch) => {
        try {
            dispatch(startSave());
            api.put('forms/' + id, data)
                .then((response) => {
                    dispatch(stopSave());
                    if (onSuccess) {
                        onSuccess(response.data);
                    }
                    return response;
                })
                .catch((error) => {
                    if (onFailure) {
                        onFailure(error);
                    }
                    dispatch(setError(error));
                    dispatch(stopSave());
                });
        } catch (e) {
            dispatch(stopSave());
            return console.error('error', e);
        }
    };

export const fetchFormContextAction =
    ({ queryParams, onSuccess, onFailure }) =>
    async (dispatch) => {
        try {
            let query = transformFiltersToQuery(queryParams);
            api.get('forms/context' + query)
                .then((response) => {
                    dispatch(setFormConfig(response.data));
                    onSuccess?.(response.data);
                    return response;
                })
                .catch((error) => {
                    onFailure?.(error);
                    dispatch(setError(error));
                });
        } catch (e) {
            return console.error('error', e);
        }
    };

export default formSlice.reducer;
